import { list } from "@mc/mc-legacy";
import QSignAdminApi from "../api/gen/qsign/QSignAdminApi";
export const SIGN_CONNECTOR_LIST = "signConnectorList";
export function fetchSignConnectorsIfNeeded(force = false) {
  return (dispatch, getState) => {
    dispatch(
      list.SimpleListActions.fetchIfNeeded(
        SIGN_CONNECTOR_LIST,
        null,
        (parent, filter) => {
          return QSignAdminApi.findSignConnectors();
        },
        force
      )
    );
  };
}
export function invalidate() {
  return dispatch => {
      dispatch(list.SimpleListActions.invalidate(SIGN_CONNECTOR_LIST, 0));
  }
}
